import { ForexBuyDraft } from "@/feature/Forex/api/form/forex-form.interface";

export enum ForexStatus {
	DRAFT = 'DRAFT',
	ON_ACCOUNTANT_LIST = 'ON_ACCOUNTANT_LIST',
	ON_DIRECTOR_LIST = 'ON_DIRECTOR_LIST',
	DELETED_BY_ACCOUNTANT = 'DELETED_BY_ACCOUNTANT',
	DELETED_BY_DIRECTOR = 'DELETED_BY_DIRECTOR',
	ON_PROCESSING_LIST = 'ON_PROCESSING_LIST',
	INTRODUCED = 'INTRODUCED',
	BANK_REVIEW = 'BANK_REVIEW',
	CONFIRMED = 'CONFIRMED',
	CONDUCTED_GO = 'CONDUCTED_GO',
	REJECTED = 'REJECTED',
	DELETED = 'DELETED',
}

export enum ForexHistoryField {
	fromRequestAmount = 'fromRequestAmount',
	toRequestAmount = 'toRequestAmount',
	id = 'id',
	status = 'status',
	fromOperDay = 'fromOperDay',
	toOperDay = 'toOperDay',
	type = 'type',
	currency = 'currency',
}

export interface ForexHistoryItem extends ForexBuyDraft {
	loaded?: boolean
	cbsId?: number | string | null
}
